var ee, p, Ue, W, he, Oe, _e, O = {}, De = [], rt = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, te = Array.isArray;
function q(t, e) {
  for (var r in e)
    t[r] = e[r];
  return t;
}
function Fe(t) {
  var e = t.parentNode;
  e && e.removeChild(t);
}
function ce(t, e, r) {
  var n, l, o, u = {};
  for (o in e)
    o == "key" ? n = e[o] : o == "ref" ? l = e[o] : u[o] = e[o];
  if (arguments.length > 2 && (u.children = arguments.length > 3 ? ee.call(arguments, 2) : r), typeof t == "function" && t.defaultProps != null)
    for (o in t.defaultProps)
      u[o] === void 0 && (u[o] = t.defaultProps[o]);
  return j(t, u, n, l, null);
}
function j(t, e, r, n, l) {
  var o = { type: t, props: e, key: r, ref: n, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: l ?? ++Ue };
  return l == null && p.vnode != null && p.vnode(o), o;
}
function B(t) {
  return t.children;
}
function R(t, e) {
  this.props = t, this.context = e;
}
function F(t, e) {
  if (e == null)
    return t.__ ? F(t.__, t.__.__k.indexOf(t) + 1) : null;
  for (var r; e < t.__k.length; e++)
    if ((r = t.__k[e]) != null && r.__e != null)
      return r.__e;
  return typeof t.type == "function" ? F(t) : null;
}
function Ve(t) {
  var e, r;
  if ((t = t.__) != null && t.__c != null) {
    for (t.__e = t.__c.base = null, e = 0; e < t.__k.length; e++)
      if ((r = t.__k[e]) != null && r.__e != null) {
        t.__e = t.__c.base = r.__e;
        break;
      }
    return Ve(t);
  }
}
function me(t) {
  (!t.__d && (t.__d = !0) && W.push(t) && !K.__r++ || he !== p.debounceRendering) && ((he = p.debounceRendering) || Oe)(K);
}
function K() {
  var t, e, r, n, l, o, u, i, s;
  for (W.sort(_e); t = W.shift(); )
    t.__d && (e = W.length, n = void 0, l = void 0, o = void 0, i = (u = (r = t).__v).__e, (s = r.__P) && (n = [], l = [], (o = q({}, u)).__v = u.__v + 1, se(s, u, o, r.__n, s.ownerSVGElement !== void 0, u.__h != null ? [i] : null, n, i ?? F(u), u.__h, l), ze(n, u, l), u.__e != i && Ve(u)), W.length > e && W.sort(_e));
  K.__r = 0;
}
function Ye(t, e, r, n, l, o, u, i, s, h, m) {
  var _, v, d, c, a, x, g, w, $, M = 0, b = n && n.__k || De, C = b.length, L = C, H = e.length;
  for (r.__k = [], _ = 0; _ < H; _++)
    (c = r.__k[_] = (c = e[_]) == null || typeof c == "boolean" || typeof c == "function" ? null : typeof c == "string" || typeof c == "number" || typeof c == "bigint" ? j(null, c, null, null, c) : te(c) ? j(B, { children: c }, null, null, null) : c.__b > 0 ? j(c.type, c.props, c.key, c.ref ? c.ref : null, c.__v) : c) != null ? (c.__ = r, c.__b = r.__b + 1, (w = nt(c, b, g = _ + M, L)) === -1 ? d = O : (d = b[w] || O, b[w] = void 0, L--), se(t, c, d, l, o, u, i, s, h, m), a = c.__e, (v = c.ref) && d.ref != v && (d.ref && ae(d.ref, null, c), m.push(v, c.__c || a, c)), a != null && (x == null && (x = a), ($ = d === O || d.__v === null) ? w == -1 && M-- : w !== g && (w === g + 1 ? M++ : w > g ? L > H - g ? M += w - g : M-- : M = w < g && w == g - 1 ? w - g : 0), g = _ + M, typeof c.type != "function" || w === g && d.__k !== c.__k ? typeof c.type == "function" || w === g && !$ ? c.__d !== void 0 ? (s = c.__d, c.__d = void 0) : s = a.nextSibling : s = je(t, a, s) : s = Xe(c, s, t), typeof r.type == "function" && (r.__d = s))) : (d = b[_]) && d.key == null && d.__e && (d.__e == s && (s = F(d)), ie(d, d, !1), b[_] = null);
  for (r.__e = x, _ = C; _--; )
    b[_] != null && (typeof r.type == "function" && b[_].__e != null && b[_].__e == r.__d && (r.__d = b[_].__e.nextSibling), ie(b[_], b[_]));
}
function Xe(t, e, r) {
  for (var n, l = t.__k, o = 0; l && o < l.length; o++)
    (n = l[o]) && (n.__ = t, e = typeof n.type == "function" ? Xe(n, e, r) : je(r, n.__e, e));
  return e;
}
function Z(t, e) {
  return e = e || [], t == null || typeof t == "boolean" || (te(t) ? t.some(function(r) {
    Z(r, e);
  }) : e.push(t)), e;
}
function je(t, e, r) {
  return r == null || r.parentNode !== t ? t.insertBefore(e, null) : e == r && e.parentNode != null || t.insertBefore(e, r), e.nextSibling;
}
function nt(t, e, r, n) {
  var l = t.key, o = t.type, u = r - 1, i = r + 1, s = e[r];
  if (s === null || s && l == s.key && o === s.type)
    return r;
  if (n > (s != null ? 1 : 0))
    for (; u >= 0 || i < e.length; ) {
      if (u >= 0) {
        if ((s = e[u]) && l == s.key && o === s.type)
          return u;
        u--;
      }
      if (i < e.length) {
        if ((s = e[i]) && l == s.key && o === s.type)
          return i;
        i++;
      }
    }
  return -1;
}
function ot(t, e, r, n, l) {
  var o;
  for (o in r)
    o === "children" || o === "key" || o in e || Q(t, o, null, r[o], n);
  for (o in e)
    l && typeof e[o] != "function" || o === "children" || o === "key" || o === "value" || o === "checked" || r[o] === e[o] || Q(t, o, e[o], r[o], n);
}
function ve(t, e, r) {
  e[0] === "-" ? t.setProperty(e, r ?? "") : t[e] = r == null ? "" : typeof r != "number" || rt.test(e) ? r : r + "px";
}
function Q(t, e, r, n, l) {
  var o;
  e:
    if (e === "style")
      if (typeof r == "string")
        t.style.cssText = r;
      else {
        if (typeof n == "string" && (t.style.cssText = n = ""), n)
          for (e in n)
            r && e in r || ve(t.style, e, "");
        if (r)
          for (e in r)
            n && r[e] === n[e] || ve(t.style, e, r[e]);
      }
    else if (e[0] === "o" && e[1] === "n")
      o = e !== (e = e.replace(/(PointerCapture)$|Capture$/, "$1")), e = e.toLowerCase() in t ? e.toLowerCase().slice(2) : e.slice(2), t.l || (t.l = {}), t.l[e + o] = r, r ? n || t.addEventListener(e, o ? ge : ye, o) : t.removeEventListener(e, o ? ge : ye, o);
    else if (e !== "dangerouslySetInnerHTML") {
      if (l)
        e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (e !== "width" && e !== "height" && e !== "href" && e !== "list" && e !== "form" && e !== "tabIndex" && e !== "download" && e !== "rowSpan" && e !== "colSpan" && e in t)
        try {
          t[e] = r ?? "";
          break e;
        } catch {
        }
      typeof r == "function" || (r == null || r === !1 && e[4] !== "-" ? t.removeAttribute(e) : t.setAttribute(e, r));
    }
}
function ye(t) {
  return this.l[t.type + !1](p.event ? p.event(t) : t);
}
function ge(t) {
  return this.l[t.type + !0](p.event ? p.event(t) : t);
}
function se(t, e, r, n, l, o, u, i, s, h) {
  var m, _, v, d, c, a, x, g, w, $, M, b, C, L, H, E = e.type;
  if (e.constructor !== void 0)
    return null;
  r.__h != null && (s = r.__h, i = e.__e = r.__e, e.__h = null, o = [i]), (m = p.__b) && m(e);
  e:
    if (typeof E == "function")
      try {
        if (g = e.props, w = (m = E.contextType) && n[m.__c], $ = m ? w ? w.props.value : m.__ : n, r.__c ? x = (_ = e.__c = r.__c).__ = _.__E : ("prototype" in E && E.prototype.render ? e.__c = _ = new E(g, $) : (e.__c = _ = new R(g, $), _.constructor = E, _.render = _t), w && w.sub(_), _.props = g, _.state || (_.state = {}), _.context = $, _.__n = n, v = _.__d = !0, _.__h = [], _._sb = []), _.__s == null && (_.__s = _.state), E.getDerivedStateFromProps != null && (_.__s == _.state && (_.__s = q({}, _.__s)), q(_.__s, E.getDerivedStateFromProps(g, _.__s))), d = _.props, c = _.state, _.__v = e, v)
          E.getDerivedStateFromProps == null && _.componentWillMount != null && _.componentWillMount(), _.componentDidMount != null && _.__h.push(_.componentDidMount);
        else {
          if (E.getDerivedStateFromProps == null && g !== d && _.componentWillReceiveProps != null && _.componentWillReceiveProps(g, $), !_.__e && (_.shouldComponentUpdate != null && _.shouldComponentUpdate(g, _.__s, $) === !1 || e.__v === r.__v)) {
            for (e.__v !== r.__v && (_.props = g, _.state = _.__s, _.__d = !1), e.__e = r.__e, e.__k = r.__k, e.__k.forEach(function(I) {
              I && (I.__ = e);
            }), M = 0; M < _._sb.length; M++)
              _.__h.push(_._sb[M]);
            _._sb = [], _.__h.length && u.push(_);
            break e;
          }
          _.componentWillUpdate != null && _.componentWillUpdate(g, _.__s, $), _.componentDidUpdate != null && _.__h.push(function() {
            _.componentDidUpdate(d, c, a);
          });
        }
        if (_.context = $, _.props = g, _.__P = t, _.__e = !1, b = p.__r, C = 0, "prototype" in E && E.prototype.render) {
          for (_.state = _.__s, _.__d = !1, b && b(e), m = _.render(_.props, _.state, _.context), L = 0; L < _._sb.length; L++)
            _.__h.push(_._sb[L]);
          _._sb = [];
        } else
          do
            _.__d = !1, b && b(e), m = _.render(_.props, _.state, _.context), _.state = _.__s;
          while (_.__d && ++C < 25);
        _.state = _.__s, _.getChildContext != null && (n = q(q({}, n), _.getChildContext())), v || _.getSnapshotBeforeUpdate == null || (a = _.getSnapshotBeforeUpdate(d, c)), Ye(t, te(H = m != null && m.type === B && m.key == null ? m.props.children : m) ? H : [H], e, r, n, l, o, u, i, s, h), _.base = e.__e, e.__h = null, _.__h.length && u.push(_), x && (_.__E = _.__ = null);
      } catch (I) {
        e.__v = null, (s || o != null) && (e.__e = i, e.__h = !!s, o[o.indexOf(i)] = null), p.__e(I, e, r);
      }
    else
      o == null && e.__v === r.__v ? (e.__k = r.__k, e.__e = r.__e) : e.__e = lt(r.__e, e, r, n, l, o, u, s, h);
  (m = p.diffed) && m(e);
}
function ze(t, e, r) {
  for (var n = 0; n < r.length; n++)
    ae(r[n], r[++n], r[++n]);
  p.__c && p.__c(e, t), t.some(function(l) {
    try {
      t = l.__h, l.__h = [], t.some(function(o) {
        o.call(l);
      });
    } catch (o) {
      p.__e(o, l.__v);
    }
  });
}
function lt(t, e, r, n, l, o, u, i, s) {
  var h, m, _, v = r.props, d = e.props, c = e.type, a = 0;
  if (c === "svg" && (l = !0), o != null) {
    for (; a < o.length; a++)
      if ((h = o[a]) && "setAttribute" in h == !!c && (c ? h.localName === c : h.nodeType === 3)) {
        t = h, o[a] = null;
        break;
      }
  }
  if (t == null) {
    if (c === null)
      return document.createTextNode(d);
    t = l ? document.createElementNS("http://www.w3.org/2000/svg", c) : document.createElement(c, d.is && d), o = null, i = !1;
  }
  if (c === null)
    v === d || i && t.data === d || (t.data = d);
  else {
    if (o = o && ee.call(t.childNodes), m = (v = r.props || O).dangerouslySetInnerHTML, _ = d.dangerouslySetInnerHTML, !i) {
      if (o != null)
        for (v = {}, a = 0; a < t.attributes.length; a++)
          v[t.attributes[a].name] = t.attributes[a].value;
      (_ || m) && (_ && (m && _.__html == m.__html || _.__html === t.innerHTML) || (t.innerHTML = _ && _.__html || ""));
    }
    if (ot(t, d, v, l, i), _)
      e.__k = [];
    else if (Ye(t, te(a = e.props.children) ? a : [a], e, r, n, l && c !== "foreignObject", o, u, o ? o[0] : r.__k && F(r, 0), i, s), o != null)
      for (a = o.length; a--; )
        o[a] != null && Fe(o[a]);
    i || ("value" in d && (a = d.value) !== void 0 && (a !== t.value || c === "progress" && !a || c === "option" && a !== v.value) && Q(t, "value", a, v.value, !1), "checked" in d && (a = d.checked) !== void 0 && a !== t.checked && Q(t, "checked", a, v.checked, !1));
  }
  return t;
}
function ae(t, e, r) {
  try {
    typeof t == "function" ? t(e) : t.current = e;
  } catch (n) {
    p.__e(n, r);
  }
}
function ie(t, e, r) {
  var n, l;
  if (p.unmount && p.unmount(t), (n = t.ref) && (n.current && n.current !== t.__e || ae(n, null, e)), (n = t.__c) != null) {
    if (n.componentWillUnmount)
      try {
        n.componentWillUnmount();
      } catch (o) {
        p.__e(o, e);
      }
    n.base = n.__P = null, t.__c = void 0;
  }
  if (n = t.__k)
    for (l = 0; l < n.length; l++)
      n[l] && ie(n[l], e, r || typeof t.type != "function");
  r || t.__e == null || Fe(t.__e), t.__ = t.__e = t.__d = void 0;
}
function _t(t, e, r) {
  return this.constructor(t, r);
}
function ct(t, e, r) {
  var n, l, o, u;
  p.__ && p.__(t, e), l = (n = typeof r == "function") ? null : r && r.__k || e.__k, o = [], u = [], se(e, t = (!n && r || e).__k = ce(B, null, [t]), l || O, O, e.ownerSVGElement !== void 0, !n && r ? [r] : l ? null : e.firstChild ? ee.call(e.childNodes) : null, o, !n && r ? r : l ? l.__e : e.firstChild, n, u), ze(o, t, u);
}
ee = De.slice, p = { __e: function(t, e, r, n) {
  for (var l, o, u; e = e.__; )
    if ((l = e.__c) && !l.__)
      try {
        if ((o = l.constructor) && o.getDerivedStateFromError != null && (l.setState(o.getDerivedStateFromError(t)), u = l.__d), l.componentDidCatch != null && (l.componentDidCatch(t, n || {}), u = l.__d), u)
          return l.__E = l;
      } catch (i) {
        t = i;
      }
  throw t;
} }, Ue = 0, R.prototype.setState = function(t, e) {
  var r;
  r = this.__s != null && this.__s !== this.state ? this.__s : this.__s = q({}, this.state), typeof t == "function" && (t = t(q({}, r), this.props)), t && q(r, t), t != null && this.__v && (e && this._sb.push(e), me(this));
}, R.prototype.forceUpdate = function(t) {
  this.__v && (this.__e = !0, t && this.__h.push(t), me(this));
}, R.prototype.render = B, W = [], Oe = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, _e = function(t, e) {
  return t.__v.__b - e.__v.__b;
}, K.__r = 0;
var V, S, oe, we, J = 0, Ge = [], z = [], be = p.__b, Se = p.__r, xe = p.diffed, Me = p.__c, $e = p.unmount;
function pe(t, e) {
  p.__h && p.__h(S, t, J || e), J = 0;
  var r = S.__H || (S.__H = { __: [], __h: [] });
  return t >= r.__.length && r.__.push({ __V: z }), r.__[t];
}
function U(t) {
  return J = 1, it(Ze, t);
}
function it(t, e, r) {
  var n = pe(V++, 2);
  if (n.t = t, !n.__c && (n.__ = [r ? r(e) : Ze(void 0, e), function(i) {
    var s = n.__N ? n.__N[0] : n.__[0], h = n.t(s, i);
    s !== h && (n.__N = [h, n.__[1]], n.__c.setState({}));
  }], n.__c = S, !S.u)) {
    var l = function(i, s, h) {
      if (!n.__c.__H)
        return !0;
      var m = n.__c.__H.__.filter(function(v) {
        return v.__c;
      });
      if (m.every(function(v) {
        return !v.__N;
      }))
        return !o || o.call(this, i, s, h);
      var _ = !1;
      return m.forEach(function(v) {
        if (v.__N) {
          var d = v.__[0];
          v.__ = v.__N, v.__N = void 0, d !== v.__[0] && (_ = !0);
        }
      }), !(!_ && n.__c.props === i) && (!o || o.call(this, i, s, h));
    };
    S.u = !0;
    var o = S.shouldComponentUpdate, u = S.componentWillUpdate;
    S.componentWillUpdate = function(i, s, h) {
      if (this.__e) {
        var m = o;
        o = void 0, l(i, s, h), o = m;
      }
      u && u.call(this, i, s, h);
    }, S.shouldComponentUpdate = l;
  }
  return n.__N || n.__;
}
function A(t, e) {
  var r = pe(V++, 3);
  !p.__s && Ke(r.__H, e) && (r.__ = t, r.i = e, S.__H.__h.push(r));
}
function k(t) {
  return J = 5, ut(function() {
    return { current: t };
  }, []);
}
function ut(t, e) {
  var r = pe(V++, 7);
  return Ke(r.__H, e) ? (r.__V = t(), r.i = e, r.__h = t, r.__V) : r.__;
}
function st() {
  for (var t; t = Ge.shift(); )
    if (t.__P && t.__H)
      try {
        t.__H.__h.forEach(G), t.__H.__h.forEach(ue), t.__H.__h = [];
      } catch (e) {
        t.__H.__h = [], p.__e(e, t.__v);
      }
}
p.__b = function(t) {
  S = null, be && be(t);
}, p.__r = function(t) {
  Se && Se(t), V = 0;
  var e = (S = t.__c).__H;
  e && (oe === S ? (e.__h = [], S.__h = [], e.__.forEach(function(r) {
    r.__N && (r.__ = r.__N), r.__V = z, r.__N = r.i = void 0;
  })) : (e.__h.forEach(G), e.__h.forEach(ue), e.__h = [], V = 0)), oe = S;
}, p.diffed = function(t) {
  xe && xe(t);
  var e = t.__c;
  e && e.__H && (e.__H.__h.length && (Ge.push(e) !== 1 && we === p.requestAnimationFrame || ((we = p.requestAnimationFrame) || at)(st)), e.__H.__.forEach(function(r) {
    r.i && (r.__H = r.i), r.__V !== z && (r.__ = r.__V), r.i = void 0, r.__V = z;
  })), oe = S = null;
}, p.__c = function(t, e) {
  e.some(function(r) {
    try {
      r.__h.forEach(G), r.__h = r.__h.filter(function(n) {
        return !n.__ || ue(n);
      });
    } catch (n) {
      e.some(function(l) {
        l.__h && (l.__h = []);
      }), e = [], p.__e(n, r.__v);
    }
  }), Me && Me(t, e);
}, p.unmount = function(t) {
  $e && $e(t);
  var e, r = t.__c;
  r && r.__H && (r.__H.__.forEach(function(n) {
    try {
      G(n);
    } catch (l) {
      e = l;
    }
  }), r.__H = void 0, e && p.__e(e, r.__v));
};
var Ee = typeof requestAnimationFrame == "function";
function at(t) {
  var e, r = function() {
    clearTimeout(n), Ee && cancelAnimationFrame(e), setTimeout(t);
  }, n = setTimeout(r, 100);
  Ee && (e = requestAnimationFrame(r));
}
function G(t) {
  var e = S, r = t.__c;
  typeof r == "function" && (t.__c = void 0, r()), S = e;
}
function ue(t) {
  var e = S;
  t.__c = t.__(), S = e;
}
function Ke(t, e) {
  return !t || t.length !== e.length || e.some(function(r, n) {
    return r !== t[n];
  });
}
function Ze(t, e) {
  return typeof e == "function" ? e(t) : e;
}
function Qe(t, e) {
  for (var r in e)
    t[r] = e[r];
  return t;
}
function ke(t, e) {
  for (var r in t)
    if (r !== "__source" && !(r in e))
      return !0;
  for (var n in e)
    if (n !== "__source" && t[n] !== e[n])
      return !0;
  return !1;
}
function Le(t) {
  this.props = t;
}
(Le.prototype = new R()).isPureReactComponent = !0, Le.prototype.shouldComponentUpdate = function(t, e) {
  return ke(this.props, t) || ke(this.state, e);
};
var Ce = p.__b;
p.__b = function(t) {
  t.type && t.type.__f && t.ref && (t.props.ref = t.ref, t.ref = null), Ce && Ce(t);
};
var pt = typeof Symbol < "u" && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function fe(t) {
  function e(r) {
    var n = Qe({}, r);
    return delete n.ref, t(n, r.ref || null);
  }
  return e.$$typeof = pt, e.render = e, e.prototype.isReactComponent = e.__f = !0, e.displayName = "ForwardRef(" + (t.displayName || t.name) + ")", e;
}
var ft = p.__e;
p.__e = function(t, e, r, n) {
  if (t.then) {
    for (var l, o = e; o = o.__; )
      if ((l = o.__c) && l.__c)
        return e.__e == null && (e.__e = r.__e, e.__k = r.__k), l.__c(t, e);
  }
  ft(t, e, r, n);
};
var Ne = p.unmount;
function Je(t, e, r) {
  return t && (t.__c && t.__c.__H && (t.__c.__H.__.forEach(function(n) {
    typeof n.__c == "function" && n.__c();
  }), t.__c.__H = null), (t = Qe({}, t)).__c != null && (t.__c.__P === r && (t.__c.__P = e), t.__c = null), t.__k = t.__k && t.__k.map(function(n) {
    return Je(n, e, r);
  })), t;
}
function et(t, e, r) {
  return t && (t.__v = null, t.__k = t.__k && t.__k.map(function(n) {
    return et(n, e, r);
  }), t.__c && t.__c.__P === e && (t.__e && r.insertBefore(t.__e, t.__d), t.__c.__e = !0, t.__c.__P = r)), t;
}
function le() {
  this.__u = 0, this.t = null, this.__b = null;
}
function tt(t) {
  var e = t.__.__c;
  return e && e.__a && e.__a(t);
}
function X() {
  this.u = null, this.o = null;
}
p.unmount = function(t) {
  var e = t.__c;
  e && e.__R && e.__R(), e && t.__h === !0 && (t.type = null), Ne && Ne(t);
}, (le.prototype = new R()).__c = function(t, e) {
  var r = e.__c, n = this;
  n.t == null && (n.t = []), n.t.push(r);
  var l = tt(n.__v), o = !1, u = function() {
    o || (o = !0, r.__R = null, l ? l(i) : i());
  };
  r.__R = u;
  var i = function() {
    if (!--n.__u) {
      if (n.state.__a) {
        var h = n.state.__a;
        n.__v.__k[0] = et(h, h.__c.__P, h.__c.__O);
      }
      var m;
      for (n.setState({ __a: n.__b = null }); m = n.t.pop(); )
        m.forceUpdate();
    }
  }, s = e.__h === !0;
  n.__u++ || s || n.setState({ __a: n.__b = n.__v.__k[0] }), t.then(u, u);
}, le.prototype.componentWillUnmount = function() {
  this.t = [];
}, le.prototype.render = function(t, e) {
  if (this.__b) {
    if (this.__v.__k) {
      var r = document.createElement("div"), n = this.__v.__k[0].__c;
      this.__v.__k[0] = Je(this.__b, r, n.__O = n.__P);
    }
    this.__b = null;
  }
  var l = e.__a && ce(B, null, t.fallback);
  return l && (l.__h = null), [ce(B, null, e.__a ? null : t.children), l];
};
var He = function(t, e, r) {
  if (++r[1] === r[0] && t.o.delete(e), t.props.revealOrder && (t.props.revealOrder[0] !== "t" || !t.o.size))
    for (r = t.u; r; ) {
      for (; r.length > 3; )
        r.pop()();
      if (r[1] < r[0])
        break;
      t.u = r = r[2];
    }
};
(X.prototype = new R()).__a = function(t) {
  var e = this, r = tt(e.__v), n = e.o.get(t);
  return n[0]++, function(l) {
    var o = function() {
      e.props.revealOrder ? (n.push(l), He(e, t, n)) : l();
    };
    r ? r(o) : o();
  };
}, X.prototype.render = function(t) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var e = Z(t.children);
  t.revealOrder && t.revealOrder[0] === "b" && e.reverse();
  for (var r = e.length; r--; )
    this.o.set(e[r], this.u = [1, 0, this.u]);
  return t.children;
}, X.prototype.componentDidUpdate = X.prototype.componentDidMount = function() {
  var t = this;
  this.o.forEach(function(e, r) {
    He(t, r, e);
  });
};
var dt = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, ht = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, mt = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, vt = /[A-Z0-9]/g, yt = typeof document < "u", gt = function(t) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/ : /fil|che|ra/).test(t);
};
R.prototype.isReactComponent = {}, ["componentWillMount", "componentWillReceiveProps", "componentWillUpdate"].forEach(function(t) {
  Object.defineProperty(R.prototype, t, { configurable: !0, get: function() {
    return this["UNSAFE_" + t];
  }, set: function(e) {
    Object.defineProperty(this, t, { configurable: !0, writable: !0, value: e });
  } });
});
var Te = p.event;
function wt() {
}
function bt() {
  return this.cancelBubble;
}
function St() {
  return this.defaultPrevented;
}
p.event = function(t) {
  return Te && (t = Te(t)), t.persist = wt, t.isPropagationStopped = bt, t.isDefaultPrevented = St, t.nativeEvent = t;
};
var xt = { enumerable: !1, configurable: !0, get: function() {
  return this.class;
} }, Pe = p.vnode;
p.vnode = function(t) {
  typeof t.type == "string" && function(e) {
    var r = e.props, n = e.type, l = {};
    for (var o in r) {
      var u = r[o];
      if (!(o === "value" && "defaultValue" in r && u == null || yt && o === "children" && n === "noscript" || o === "class" || o === "className")) {
        var i = o.toLowerCase();
        o === "defaultValue" && "value" in r && r.value == null ? o = "value" : o === "download" && u === !0 ? u = "" : i === "ondoubleclick" ? o = "ondblclick" : i !== "onchange" || n !== "input" && n !== "textarea" || gt(r.type) ? i === "onfocus" ? o = "onfocusin" : i === "onblur" ? o = "onfocusout" : mt.test(o) ? o = i : n.indexOf("-") === -1 && ht.test(o) ? o = o.replace(vt, "-$&").toLowerCase() : u === null && (u = void 0) : i = o = "oninput", i === "oninput" && l[o = i] && (o = "oninputCapture"), l[o] = u;
      }
    }
    n == "select" && l.multiple && Array.isArray(l.value) && (l.value = Z(r.children).forEach(function(s) {
      s.props.selected = l.value.indexOf(s.props.value) != -1;
    })), n == "select" && l.defaultValue != null && (l.value = Z(r.children).forEach(function(s) {
      s.props.selected = l.multiple ? l.defaultValue.indexOf(s.props.value) != -1 : l.defaultValue == s.props.value;
    })), r.class && !r.className ? (l.class = r.class, Object.defineProperty(l, "className", xt)) : (r.className && !r.class || r.class && r.className) && (l.class = l.className = r.className), e.props = l;
  }(t), t.$$typeof = dt, Pe && Pe(t);
};
var Re = p.__r;
p.__r = function(t) {
  Re && Re(t), t.__c;
};
var Ae = p.diffed;
p.diffed = function(t) {
  Ae && Ae(t);
  var e = t.props, r = t.__e;
  r != null && t.type === "textarea" && "value" in e && e.value !== r.value && (r.value = e.value == null ? "" : e.value);
};
var Mt = 0;
function f(t, e, r, n, l, o) {
  var u, i, s = {};
  for (i in e)
    i == "ref" ? u = e[i] : s[i] = e[i];
  var h = { type: t, props: s, key: r, ref: u, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: --Mt, __source: l, __self: o };
  if (typeof t == "function" && (u = t.defaultProps))
    for (i in u)
      s[i] === void 0 && (s[i] = u[i]);
  return p.vnode && p.vnode(h), h;
}
const qe = (t) => {
  let [e, r, n] = t.replace("rgb(", "").replace(")", "").split(",").map((l) => Number(l));
  return {
    r: e,
    g: r,
    b: n
  };
}, Ie = (t, e, r) => {
  const n = qe(t), l = qe(e), o = (u) => Math.round(n[u] * (1 - r) + l[u] * r);
  return {
    r: o("r"),
    g: o("g"),
    b: o("b")
  };
}, We = (t) => {
  const e = document.querySelectorAll(".cursor").length;
  if (t === 0 || t === e)
    return 0;
  if (t === Math.floor(e / 2))
    return 1;
  if (t > 0 && t < Math.floor(e / 2))
    return t / Math.ceil(e / 2);
  if (t > Math.floor(e / 2) && t < Math.floor(e))
    return (Math.floor(e) - t) / Math.ceil(e / 2);
}, Be = (t) => {
  var e = parseInt(t.replace("#", ""), 16), r = e >> 16 & 255, n = e >> 8 & 255, l = e & 255;
  return `rgb(${r},${n},${l})`;
}, $t = ({
  paused: t,
  length: e,
  colour1: r,
  colour2: n
}) => {
  var l = k({});
  r = Be(r), n = Be(n);
  var o = {
    x: null,
    y: null
  }, u = {
    x: null,
    y: null
  };
  const i = k(0), s = k(0);
  function h(a) {
    var x = Math.PI;
    return a * (180 / x);
  }
  const m = fe(({
    top: a,
    left: x,
    deg: g,
    side: w,
    index: $
  }, M) => {
    let b = Ie(r, n, We($));
    return f("div", {
      className: "cursor-wrapper",
      ref: M,
      children: f("div", {
        className: "cursor",
        style: {
          backgroundColor: `rgb(${b.r},${b.g},${b.b})`
          // border: `1pt solid ${getRandomColour()}`
        }
      })
    });
  }), _ = Array.from(new Array(e)).map((a, x) => f(m, {
    index: x,
    ref: (g) => l.current[x] = g
  }, `cursor_paw_${x}`)), v = (a) => {
    let x = document.querySelector(".app-wrapper").getBoundingClientRect();
    i.current > document.querySelectorAll(".cursor-wrapper").length - 1 && (i.current = 0, u.x = a.clientX - x.left, u.y = a.clientY - x.top);
    let g = a.clientX - u.x, w = a.clientY - u.y, $ = h(Math.atan2(w, g));
    l.current[i.current].children[0].style.transform = `rotate(${$ + 90}deg)`, l.current[i.current].style.left = `${a.clientX - x.left}px`, l.current[i.current].style.top = `${a.clientY - x.top}px`, Object.keys(l.current).forEach((M, b) => {
      if (!l.current[M])
        return;
      let C = Ie(r, n, We(b));
      l.current[M].children[0].style.background = `rgb(${C.r},${C.g},${C.b})`, l.current[M].children[0].style.filter = "blur(10px) contrast(1.5)";
    }), l.current[i.current].children[0].style.background = `${l.current[i.current].children[0].style.background} url("https://cdn.shopify.com/s/files/1/0058/4538/5314/files/cursor-face.svg?v=1695789029") no-repeat center center`, l.current[i.current].children[0].style.filter = "unset", l.current[i.current].style.zIndex = "69";
  }, d = (a) => {
    !window.paused && !window.newRound && v(a);
  }, c = (a) => {
    window.paused || ((o.x || o.y) && (s.current += Math.sqrt(Math.pow(o.y - a.clientY, 2) + Math.pow(o.x - a.clientX, 2))), o.x = a.clientX, o.y = a.clientY, s.current > 20 && (v(a), s.current = 0, i.current++, i.current > _.length - 1 && (i.current = 0), u.x = a.clientX, u.y = a.clientY));
  };
  return A(() => {
    const a = document.querySelector(".app-wrapper");
    return a.addEventListener("mouseup", d), a.addEventListener("mousemove", c), () => {
      a.removeEventListener("mouseup", d), a.removeEventListener("mousemove", c);
    };
  }, [r, n, l, d, c]), f("div", {
    id: "cursor",
    children: _
  });
};
const Et = ({
  length: t
}) => {
  var e = k({}), r = {
    x: null,
    y: null
  }, n = {
    x: null,
    y: null
  };
  k(0);
  const l = k(0), o = document.querySelector(".game-info"), u = fe(({
    top: s,
    left: h,
    deg: m,
    side: _
  }, v) => {
    let c = document.querySelector(".app-wrapper").getBoundingClientRect();
    return f("div", {
      className: "enemy",
      style: {
        background: `url("${["https://cdn.shopify.com/s/files/1/0058/4538/5314/files/enemy1.svg?v=1695789029", "https://cdn.shopify.com/s/files/1/0058/4538/5314/files/enemy2.svg?v=1695789029", "https://cdn.shopify.com/s/files/1/0058/4538/5314/files/enemy3.svg?v=1695789029", "https://cdn.shopify.com/s/files/1/0058/4538/5314/files/enemy4.svg?v=1695789029"][Math.floor(Math.random() * 4)]}")  no-repeat center center`,
        left: Math.min(c.width - 80, Math.floor(Math.random() * c.width)),
        top: Math.min(c.height - 80, Math.max(3 * parseFloat(getComputedStyle(o).fontSize), Math.floor(Math.random() * c.height)))
      },
      "data-rotation": ["NE", "SE", "SW", "NW"][Math.floor(Math.random() * 4)],
      ref: v
    });
  }), i = Array.from(new Array(t)).map((s, h) => f(u, {
    ref: (m) => e.current[h] = m
  }, `enemy_paw_${h}`));
  return A(() => {
    let s = document.querySelector(".app-wrapper"), h = s.getBoundingClientRect();
    const m = (d) => {
      Object.keys(e.current).forEach((c) => {
        e.current[c] && (e.current[c].dataset.rotation === "NE" ? (e.current[c].style.left = parseInt(e.current[c].style.left.replace("px", "")) + 1 + "px", e.current[c].style.top = parseInt(e.current[c].style.top.replace("px", "")) - 1 + "px", e.current[c].style.left.replace("px", "") > h.width - 80 && (e.current[c].dataset.rotation = "NW"), e.current[c].style.top.replace("px", "") < 40 && (e.current[c].dataset.rotation = "SE")) : e.current[c].dataset.rotation === "SE" ? (e.current[c].style.left = parseInt(e.current[c].style.left.replace("px", "")) + 1 + "px", e.current[c].style.top = parseInt(e.current[c].style.top.replace("px", "")) + 1 + "px", e.current[c].style.left.replace("px", "") > h.width - 80 && (e.current[c].dataset.rotation = "SW"), e.current[c].style.top.replace("px", "") > h.height - 80 && (e.current[c].dataset.rotation = "NE")) : e.current[c].dataset.rotation === "SW" ? (e.current[c].style.left = parseInt(e.current[c].style.left.replace("px", "")) - 1 + "px", e.current[c].style.top = parseInt(e.current[c].style.top.replace("px", "")) + 1 + "px", e.current[c].style.left.replace("px", "") < 0 && (e.current[c].dataset.rotation = "SE"), e.current[c].style.top.replace("px", "") > h.height - 80 && (e.current[c].dataset.rotation = "NW")) : e.current[c].dataset.rotation === "NW" && (e.current[c].style.left = parseInt(e.current[c].style.left.replace("px", "")) - 1 + "px", e.current[c].style.top = parseInt(e.current[c].style.top.replace("px", "")) - 1 + "px", e.current[c].style.left.replace("px", "") < 0 && (e.current[c].dataset.rotation = "NE"), e.current[c].style.top.replace("px", "") < 40 && (e.current[c].dataset.rotation = "SW")));
      });
    };
    let _ = setInterval(() => {
      window.paused && m();
    }, 20);
    const v = (d) => {
      window.paused || ((r.x || r.y) && (l.current += Math.sqrt(Math.pow(r.y - d.clientY, 2) + Math.pow(r.x - d.clientX, 2))), r.x = d.clientX, r.y = d.clientY, l.current > 10 && (d.clientX - n.x, d.clientY - n.y, m(), l.current = 0, n.x = d.clientX, n.y = d.clientY));
    };
    return s.addEventListener("mousemove", v), () => {
      s.removeEventListener("mousemove", v), clearInterval(_);
    };
  }, [t, e]), f("div", {
    id: "enemies",
    className: "large",
    children: i
  });
}, kt = ({
  length: t
}) => {
  var e = k({});
  const r = Array.from(new Array(t)).map((n, l) => f(Lt, {
    ref: (o) => e.current[l] = o
  }, `enemy_paw_${l}`));
  return f("div", {
    id: "coins",
    className: "large",
    children: r
  });
}, Lt = fe(({
  top: t,
  left: e,
  deg: r,
  side: n
}, l) => f("div", {
  className: "coin",
  style: {
    // backgroundColor: randomColour,
    background: `url("${["https://cdn.shopify.com/s/files/1/0058/4538/5314/files/treasure1.svg?v=1695789029", "https://cdn.shopify.com/s/files/1/0058/4538/5314/files/treasure2.svg?v=1695789029", "https://cdn.shopify.com/s/files/1/0058/4538/5314/files/treasure3.svg?v=1695789029", "https://cdn.shopify.com/s/files/1/0058/4538/5314/files/treasure4.svg?v=1695789029"][Math.floor(Math.random() * 4)]}") no-repeat center center`,
    left: `max(0%,calc(${Math.floor(Math.random() * 100)}% - 80px))`,
    top: `max(3em,calc(${Math.floor(Math.random() * 100)}% - 80px))`
  },
  ref: l
}));
const Ct = () => f("div", {
  id: "background",
  children: f("div", {
    id: "grain"
  })
});
function Nt() {
  const t = k(null);
  k(null);
  const e = k(null), r = k(null), n = k(null), l = k(null), o = k(null), [u, i] = U(0), [s, h] = U(!1), [m, _] = U(3);
  A(() => {
    window.paused = !0, window.newRound = !1, document.querySelector(".app-wrapper").addEventListener("contextmenu", (y) => y.preventDefault());
  }, []);
  const v = () => "#" + Math.floor(Math.random() * 16777215).toString(16), [d, c] = U(v().padEnd(7, "0")), [a, x] = U(v().padEnd(7, "0")), [g, w] = U(5), $ = () => {
    Y(!0), w(5), r.current.innerHTML = 69, e.current.innerHTML = 0, n.current.innerHTML = 1, document.querySelector(".new-round").classList.add("show"), document.querySelector(".game-menu").classList.remove("show"), document.querySelector(".game-menu__background").classList.remove("show"), l.current.innerHTML = 3, window.newRound = !0, i((y) => y + 1);
  }, M = () => {
    Y(!0), w((y) => y + 5), _((y) => y + 2), n.current.innerHTML = parseInt(n.current.innerHTML) + 1, window.newRound = !0, document.querySelector(".new-round").classList.add("show"), l.current.innerHTML = parseInt(l.current.innerHTML) + 2;
  };
  A(() => {
    document.querySelector(".app-wrapper").addEventListener("mousedown", (N) => {
      window.newRound && (window.newRound = !1, Y(!1), document.querySelector(".new-round").classList.remove("show"));
    });
  }, []);
  const b = () => {
    e.current.innerHTML = parseInt(e.current.innerHTML) + 1;
  }, C = () => {
    e.current.innerHTML = parseInt(e.current.innerHTML) - 1;
  }, L = () => {
    if (r.current.innerHTML = document.querySelectorAll(".cursor").length, document.querySelectorAll(".cursor").length === 0) {
      if (window.paused)
        return;
      h(!0), o.current.classList.add("show"), document.querySelector(".game-menu__background").classList.add("show"), document.querySelector(":root").classList.add("paused"), o.current.innerHTML = `<h1>Game Over.</h1>You made it to round: ${n.current.innerHTML} and scored: ${e.current.innerHTML} points!<br/>Click anywhere to continue.`;
    }
  };
  A(() => {
    const y = (N) => {
      s && (document.querySelector(".game-menu").classList.add("show"), h(!1), window.paused = !0, window.newRound = !1, o.current.classList.remove("show"));
    };
    return document.addEventListener("mousedown", y), () => {
      document.removeEventListener("mousedown", y);
    };
  }, [s]);
  const H = () => {
    let y = document.querySelectorAll(".coin"), N = document.querySelectorAll(".cursor-wrapper");
    window.paused || (y.length === 0 && M(), y.forEach((D) => {
      N.forEach((re) => {
        let T = re.getBoundingClientRect(), P = D.getBoundingClientRect();
        var ne = !(T.right < P.left || T.left > P.right || T.bottom < P.top || T.top > P.bottom);
        ne && (D.remove(), b(), L());
      });
    }));
  }, E = () => {
    let y = document.querySelectorAll(".enemy"), N = document.querySelectorAll(".cursor-wrapper");
    y.forEach((D) => {
      N.forEach((re) => {
        let T = re.getBoundingClientRect(), P = D.getBoundingClientRect();
        var ne = !(T.right < P.left + 25 || T.left > P.right - 25 || T.bottom < P.top + 25 || T.top > P.bottom - 25);
        ne && (D.remove(), N[N.length - 1].remove(), C(), L());
      });
    }), y && (l.current.innerHTML = y.length);
  };
  A(() => {
    const y = setInterval(() => {
      E(), H(), L();
    }, 1e3);
    return () => clearInterval(y);
  }, []), A(() => (window.addEventListener("mousemove", function(y) {
    E(), H();
  }), () => {
  }), []);
  const I = () => {
    document.querySelector(".game-board").classList.toggle("show-bounds");
  }, Y = (y) => {
    window.paused = y, window.paused ? document.querySelector(":root").classList.add("paused") : document.querySelector(":root").classList.remove("paused");
  }, de = () => {
    document.querySelector(".game-menu").classList.add("show"), document.querySelector(".new-round").classList.remove("show"), document.querySelector(".game-menu__background").classList.add("show"), Y(!0), w(5), r.current.innerHTML = 69, e.current.innerHTML = 0, n.current.innerHTML = 0;
  };
  return A(() => {
    document.addEventListener("keydown", (y) => {
      y.key === "Escape" && de(), y.key === "e" && I();
    });
  }, []), f(B, {
    children: [f("div", {
      className: "app-wrapper",
      children: [f(Ct, {}), f("div", {
        className: "game-menu__end",
        ref: o
      }), f("div", {
        className: "game-menu__background show"
      }), f("div", {
        className: "new-round",
        children: f("h1", {
          children: "Click anywhere to begin a new round!"
        })
      }), f("div", {
        className: "game-menu show",
        children: [f("div", {
          className: "game-menu__title",
          children: [f("img", {
            src: "https://cdn.shopify.com/s/files/1/0058/4538/5314/files/logo.svg?v=1695789029",
            alt: "Vite Logo"
          }), f("h1", {
            children: "Snek"
          })]
        }), f("ul", {
          className: "game-menu__controls",
          children: [f("h2", {
            children: "How to play"
          }), f("li", {
            children: "Move the cursor to draw your snake. Time only moves when you move."
          }), f("li", {
            children: "Collect coins to gain points. Collecting all of the coins will progress you to the next round."
          }), f("li", {
            children: "Avoid enemies. Each round 2 new enemies get added to the board, on top of the enemies that are already there. Getting hit by enemies will delete the enemy, lower your score by 1, and decrease your health by 1."
          }), f("li", {
            children: "Don't let your health reach 0. Each time you lose health your Snek gets slightly shorter, until there is no more. At which point the game will end."
          }), f("li", {
            children: "Do your best! Your stats are NOT recorded."
          })]
        }), f("button", {
          className: "game-menu__start",
          onClick: () => {
            i((y) => y + 1), $();
          },
          children: "Start Game"
        }), f("div", {
          className: "game-menu__customize",
          children: [f("label", {
            htmlFor: "colour1-input",
            children: "Snek Colours:"
          }), f("input", {
            id: "colour1-input",
            type: "color",
            value: d,
            onChange: (y) => {
              c(y.target.value), i((N) => N + 1);
            }
          }), f("input", {
            id: "colour2-input",
            type: "color",
            value: a,
            onChange: (y) => {
              x(y.target.value), i((N) => N + 1);
            }
          })]
        })]
      }), f("div", {
        className: "game-info",
        children: [f("div", {
          children: [f("div", {
            className: "game-info__logo",
            children: f("img", {
              src: "https://cdn.shopify.com/s/files/1/0058/4538/5314/files/logo.svg?v=1695789029",
              alt: "Snek Logo"
            })
          }), f("h1", {
            children: "Snek"
          })]
        }), f("h1", {
          children: ["Round: ", f("span", {
            ref: n,
            children: "0"
          })]
        }), f("h1", {
          children: ["Score: ", f("span", {
            ref: e,
            children: "0"
          })]
        }), f("h1", {
          children: ["Health: ", f("span", {
            ref: r,
            children: "69"
          })]
        }), f("h1", {
          children: ["Enemies: ", f("span", {
            ref: l,
            children: "0"
          })]
        }), f("button", {
          onClick: I,
          children: "Toggle Bounds (e)"
        }), f("button", {
          onClick: de,
          children: "Exit (esc)"
        })]
      })]
    }), f("div", {
      className: "game-board",
      children: [f($t, {
        ref: t,
        length: r.current ? parseInt(r.current.innerHTML) : 69,
        colour1: d,
        colour2: a
      }, u), f(Et, {
        length: l.current ? parseInt(l.current.innerHTML) : 3
      }, u + 1), f(kt, {
        length: g
      }, u + 2)]
    })]
  });
}
ct(f(Nt, {}), document.getElementById("snake-arcade-host"));
